import { FC, memo, Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import map from 'lodash/map';

import PrivateRoute from 'routes/PrivateRoute';
import withRoutes from 'hocs/withRoutes';
import { ERoutePaths } from 'types/routes/enums';

const Routes: FC<{ routes: {}[], search: string }> = ({ routes, search }) =>
  <Suspense fallback="">
    <Switch>
      {map(routes, (route, key) => <PrivateRoute {...{ ...route, search, key }} />)}
      <Redirect from="*" to={{ pathname: ERoutePaths.Root, search }} />
    </Switch>
  </Suspense>;

export default withRoutes(memo(Routes));
